import { Box, Paper, Divider, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import variables from "../../../../assets/styles/variables.module.scss";
import { TextFields } from "@mui/icons-material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";

import { useDispatch } from "react-redux";
import BaseInstance from "../../../../Services/AxiosInstance/BaseInstance";
import {
  StartLoading,
  StopLoading,
} from "../../../Store/LoadingReducer/LoaderActions";
import {
  DASHBOARD_AGENT,
  DASHBOARD_KNOWLEDGE_BASE,
} from "../../../../Services/Endpoint";
import { ShowError } from "../../../Store/MessageReducer/MsgActions";
import { DashboardStats } from "../../../Types/Dashboard";
import { useNavigate } from 'react-router-dom';

interface MyComponentProps {
  dashboardStats: DashboardStats
}
const SmallCardKnowledgeBase: React.FC<MyComponentProps> = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Paper
      onClick={() => navigate('/dashboard-analytics')}
      sx={{
        borderRadius: "12px",
        p: 3,
        display: "flex",
        flexDirection: "column",
        background: "#05dabb",
        color: variables.whiteColor,
        height: "100%",
        boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)",
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out', 
        '&:hover': {
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      {/* Header */}
      <Box display="flex" alignItems="center" mb={2}>
        <MenuBookIcon sx={{ mr: 1 }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Knowledge
        </Typography>
      </Box>

      {/* Count & Label */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          variant="subtitle1"
          fontWeight={600}
          sx={{
            textTransform: "uppercase",
            letterSpacing: "0.5px", // Optional: adds better spacing for uppercase text
          }}
        >
          KNOWLEDGE
        </Typography>
        <Typography variant="h4" fontWeight={700}>
          {props.dashboardStats.knowledge.knowledge_bases}
        </Typography>
      </Box>

      <Divider sx={{ backgroundColor: variables.whiteColor, my: 1 }} />

      {/* Bottom Section */}
      <Box>
        {/* Documents */}


        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Files
          </Typography>

          <Typography variant="body2" fontWeight={600}>
            {props.dashboardStats.knowledge.total_files}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <Typography variant="caption" sx={{ opacity: 0.85 }}>
            Total size
          </Typography>

          <Typography variant="body2" fontWeight={600}>
            {Math.round(props.dashboardStats.storage.total_size_bytes / 1048576)} MB
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default SmallCardKnowledgeBase;
